exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table td[data-v-feb6c8aa],.table th[data-v-feb6c8aa]{white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-feb6c8aa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/ClientWiseTeusTable.vue
// module id = 1856
// module chunks = 0